import { examinationURL } from "../../../utils/paths";
import { AsyncThunkConfig } from "../../../api/axiosConfig";
import { createAsyncThunk } from "@reduxjs/toolkit";
import instance, { ApiError, isAxiosError } from "../../../api/axiosConfig";
import { dispatchNotification } from "../../../utils/redux";
import { downloadFileFromArraybuffer } from "../../../utils/download";
import { getTimezoneOffset } from "../../../utils/timezone";

interface DiagnosticReportParams {
  examinationId: string;
  normSet: number;
  confidenceLevel: string;
  language: string;
}

export const downloadDiagnosticChartsReport = createAsyncThunk<
  undefined,
  DiagnosticReportParams,
  AsyncThunkConfig
>(
  "documentation/reports/diagnosticCharts",
  async ({ examinationId, normSet, confidenceLevel, language }, thunkAPI) => {
    if (!examinationId || String(examinationId) === "undefined") {
      return thunkAPI.rejectWithValue({
        message: "Nieprawidłowe parametry",
        results: null,
        error: true,
      } as ApiError);
    }

    try {
      const response = await instance.post<Blob>(
        `${examinationURL}${examinationId}/reports/diagnostic-charts/`,
        { normSet, confidenceLevel },
        {
          responseType: "arraybuffer",
          headers: {
            "Accept-Language": language,
            "X-Timezone-Offset": getTimezoneOffset().toString(),
          },
        }
      );

      downloadFileFromArraybuffer(response, "application/pdf");
    } catch (err) {
      if (isAxiosError(err) && err.response != null) {
        const extractedError = err.response.data as ApiError;

        dispatchNotification("error", extractedError.message);

        return thunkAPI.rejectWithValue(extractedError);
      }

      dispatchNotification("error");
      throw err;
    }
  }
);

export const downloadDiagnosticReport = createAsyncThunk<
  undefined,
  DiagnosticReportParams,
  AsyncThunkConfig
>(
  "documentation/reports/diagnostic",
  async ({ examinationId, normSet, confidenceLevel, language }, thunkAPI) => {
    // Sprawdź czy parametry są prawidłowe
    if (!examinationId || String(examinationId) === "undefined") {
      return thunkAPI.rejectWithValue({
        message: "Nieprawidłowe parametry",
        results: null,
        error: true,
      } as ApiError);
    }

    try {
      const response = await instance.post<Blob>(
        `${examinationURL}${examinationId}/reports/diagnostic/`,
        { normSet, confidenceLevel },
        {
          responseType: "arraybuffer",
          headers: {
            "Accept-Language": language,
            "X-Timezone-Offset": getTimezoneOffset().toString(),
          },
        }
      );

      downloadFileFromArraybuffer(response, "application/pdf");
    } catch (err) {
      if (isAxiosError(err) && err.response != null) {
        const extractedError = err.response.data as ApiError;

        dispatchNotification("error", extractedError.message);

        return thunkAPI.rejectWithValue(extractedError);
      }

      dispatchNotification("error");
      throw err;
    }
  }
);